import React from 'react';
import FilePicker from 'Components/FilePicker';

export default function ReportDocumentation({ documents, errors, handleFileRemove, handleFileSelect }) {
  return (
    <section className='scene_section'>
      <header>Inspection Report Documentation</header>
      <div className='__main-alert-label'>
      Please upload inspection report and signature page
      </div>
      <FilePicker
        editableStateSectionHeader=''
        notEditableStateSectionHeader=''
        error={errors.documents ? 'Please upload at least one file' : ''}
        sectionHeaderClassName='_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16'
        mainWrapperClassName='_min_height_auto'
        uploadButtonText='Upload'
        handleFileSelect={handleFileSelect}
        handleRemoveFile={handleFileRemove}
        files={documents}
      />
    </section>
  );
}

ReportDocumentation.defaultProps = {
  documents: [],
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/New/ReportDocumentation.jsx